var q = Object.defineProperty, G = Object.defineProperties;
var H = Object.getOwnPropertyDescriptors;
var F = Object.getOwnPropertySymbols;
var J = Object.prototype.hasOwnProperty, K = Object.prototype.propertyIsEnumerable;
var W = (v, r, t) => r in v ? q(v, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : v[r] = t, x = (v, r) => {
  for (var t in r || (r = {}))
    J.call(r, t) && W(v, t, r[t]);
  if (F)
    for (var t of F(r))
      K.call(r, t) && W(v, t, r[t]);
  return v;
}, B = (v, r) => G(v, H(r));
var O = (v, r, t) => new Promise((A, c) => {
  var o = (p) => {
    try {
      i(t.next(p));
    } catch (m) {
      c(m);
    }
  }, d = (p) => {
    try {
      i(t.throw(p));
    } catch (m) {
      c(m);
    }
  }, i = (p) => p.done ? A(p.value) : Promise.resolve(p.value).then(o, d);
  i((t = t.apply(v, r)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getRegionByIdToAnonymous as Q } from "../../request/ucenterapi/anonymous/internal/region/getRegionByIdToAnonymous/get.js";
import { getRegionListByPidToAnonymous as X } from "../../request/ucenterapi/anonymous/internal/region/getRegionListByPidToAnonymous/get.js";
import { getRegionCountryListByPid as Z } from "../../request/ucenterapi/internal/region/getRegionCountryListByPid/get.js";
import Y from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import { defineComponent as _, computed as j, watch as ee, getCurrentInstance as le, onMounted as oe, openBlock as w, createElementBlock as te, createBlock as E, createCommentVNode as S, createVNode as ae, nextTick as $ } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as L, unref as U } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { normalizeStyle as ie } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
const f = 0, y = 1, N = 2, g = 3, C = 4, ce = /* @__PURE__ */ _({
  __name: "RegionSelect",
  props: {
    disabled: { type: Boolean, default: !1 },
    disabledLength: { default: 0 },
    modelValue: { default: "" },
    type: { default: C },
    isShowCountry: { type: Boolean, default: !1 },
    mutipleVal: { type: Boolean, default: !1 },
    isAdd: { type: Boolean, default: !1 },
    isDirectly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:modelValue2", "chooseRegionData", "pids"],
  setup(v, { emit: r }) {
    const t = v, A = (a, e) => a.reduce((l, n) => l && l[n] ? l[n] : null, e), c = r, o = {
      COUNTRY: f,
      PROVINCE: y,
      CITY: N,
      AREA: g,
      COUNTY: C
    }, d = L({
      [f]: [],
      [y]: [],
      [N]: [],
      [g]: [],
      [C]: []
    }), i = L({
      [f]: void 0,
      [y]: void 0,
      [N]: void 0,
      [g]: void 0,
      [C]: void 0
    }), p = L(""), m = (a) => O(this, null, function* () {
      var e;
      i.value = {
        0: void 0,
        1: void 0,
        2: void 0,
        3: void 0,
        4: void 0
      };
      try {
        const l = yield Q({ regionId: a });
        if (l.data && l.data.pids) {
          c("update:modelValue2", l.data.pids), c("pids", l.data.pids);
          const n = l.data.pids.split(","), u = ((e = l.data.pidsName) == null ? void 0 : e.split(".")) || [];
          n.forEach((b, s) => {
            var k;
            i.value[s] = b, d.value[s] = [
              {
                id: b,
                value: b.toString(),
                label: u[s],
                name: u[s],
                pids: n.slice(0, s + 1).join(","),
                pidsName: (k = l.data) == null ? void 0 : k.pidsName
              }
            ];
          }), p.value = a;
        } else
          m("1");
      } catch (l) {
        console.error("获取区域数据失败:", l);
      }
    }), z = () => O(this, null, function* () {
      try {
        const a = yield Z();
        d.value[0] = (a.data || []).map((e) => B(x({}, e), {
          value: (e.id || "").toString(),
          // 确保是字符串类型,
          label: e.name || ""
        }));
      } catch (a) {
        console.error("获取国家列表失败:", a);
      }
    });
    j(() => {
      let a = t.type;
      return t.isShowCountry && (a += 1), `grid-template-columns: repeat(${a}, minmax(0, 1fr));`;
    });
    const M = j(() => (t.type, t.isShowCountry, `display: flex;
  flex-wrap: nowrap;
  gap: 12px;
  width: 100%;`));
    ee(
      () => t.modelValue,
      (a) => {
        if (a)
          if (t.mutipleVal) {
            const e = a.split(","), l = e[e.length - 1];
            l !== p.value && m(l);
          } else
            a !== p.value && m(a);
        else
          t.isAdd || m("1");
      },
      { immediate: !0 }
    );
    const I = (a) => a === f ? t.isShowCountry : t.type > a - 1 && i.value[f] === "1", R = (a) => t.disabled ? !0 : a === f ? t.disabledLength > f : !i.value[a - 1] || t.disabledLength > a, T = (a, e) => O(this, null, function* () {
      if (console.log("show--", a, e), a) {
        if (d.value[e].length > 1)
          if (e > 0) {
            if (d.value[e][0].pid === i.value[e - 1])
              return;
          } else
            return;
        if (e > 0) {
          const l = yield X({ regionPid: i.value[e - 1] });
          d.value[e] = (l.data || []).map((n) => B(x({}, n), {
            value: (n.id || "").toString(),
            label: n.name || ""
          }));
        } else
          yield z();
      } else
        e > 0 && P(e);
    }), P = (a) => {
      let e = "", l = [];
      for (const n in i.value) {
        const u = Number(n);
        i.value[u] && (e = i.value[u], l = d.value[u]);
      }
      if (l) {
        const n = d.value[a].find((u) => u.id === e);
        if (n) {
          const u = A(["pids"], n), b = A(["pidsName"], n);
          c("update:modelValue2", u), c("pids", u), c("chooseRegionData", {
            pids: u,
            pidsName: b
          });
        }
      }
    }, D = le(), V = (a, e) => O(this, null, function* () {
      var u, b;
      const l = {
        [f]: void 0,
        [y]: void 0,
        [N]: void 0,
        [g]: void 0,
        [C]: void 0
      }, n = {
        [f]: [],
        [y]: [],
        [N]: [],
        [g]: [],
        [C]: []
      };
      for (let s = 0; s <= e; s++)
        l[s] = i.value[s], n[s] = [...d.value[s] || []];
      if (l[e] = a, i.value = {
        [f]: void 0,
        [y]: void 0,
        [N]: void 0,
        [g]: void 0,
        [C]: void 0
      }, d.value = {
        [f]: [],
        [y]: [],
        [N]: [],
        [g]: [],
        [C]: []
      }, yield $(), i.value = l, d.value = n, p.value = a, yield $(), D && ((b = (u = D.proxy) == null ? void 0 : u.$forceUpdate) == null || b.call(u)), t.mutipleVal) {
        const s = [];
        for (const k in i.value) {
          const h = i.value[Number(k)];
          h && s.push(h);
        }
        console.log("codeList----", s), c("update:modelValue", s.join(","));
      } else {
        console.log("code----", p.value), P(e);
        let s = p.value;
        !t.isDirectly && i.value[f] === "1" && (s = i.value[C] || i.value[g] || i.value[N] || i.value[y] || p.value), c("update:modelValue", s || p.value);
      }
    });
    return oe(() => {
      if (t.modelValue)
        if (t.mutipleVal) {
          const a = t.modelValue.split(","), e = a[a.length - 1];
          m(e);
        } else
          m(t.modelValue);
      else
        t.isAdd || m("1");
    }), (a, e) => (w(), te("div", {
      class: "region-selector",
      style: ie(M.value)
    }, [
      I(o.COUNTRY) ? (w(), E(U(Y), {
        key: 0,
        style: {
          display: "inline-block",
          flex: 1,
          minWidth: "100px"
        },
        options: d.value[o.COUNTRY],
        value: i.value[o.COUNTRY],
        "onUpdate:value": [
          e[0] || (e[0] = (l) => i.value[o.COUNTRY] = l),
          e[1] || (e[1] = (l) => V(l, o.COUNTRY))
        ],
        filterable: !0,
        disabled: R(o.COUNTRY),
        placeholder: "选择国家",
        placement: "bottom",
        "render-to-body": !1,
        onFocus: e[2] || (e[2] = (l) => T(!0, o.COUNTRY))
      }, null, 8, ["options", "value", "disabled"])) : S("", !0),
      ae(U(Y), {
        style: {
          display: "inline-block",
          flex: 1,
          minWidth: "100px"
        },
        options: d.value[o.PROVINCE],
        value: i.value[o.PROVINCE],
        "onUpdate:value": [
          e[3] || (e[3] = (l) => i.value[o.PROVINCE] = l),
          e[4] || (e[4] = (l) => V(l, o.PROVINCE))
        ],
        filterable: !0,
        disabled: R(o.PROVINCE),
        placeholder: "选择省份",
        placement: "bottom",
        "render-to-body": !1,
        onFocus: e[5] || (e[5] = (l) => T(!0, o.PROVINCE))
      }, null, 8, ["options", "value", "disabled"]),
      I(o.CITY) ? (w(), E(U(Y), {
        key: 1,
        style: {
          display: "inline-block",
          flex: 1,
          minWidth: "100px"
        },
        options: d.value[o.CITY],
        value: i.value[o.CITY],
        "onUpdate:value": [
          e[6] || (e[6] = (l) => i.value[o.CITY] = l),
          e[7] || (e[7] = (l) => V(l, o.CITY))
        ],
        filterable: !0,
        placeholder: "选择城市",
        placement: "bottom",
        "render-to-body": !1,
        disabled: R(o.CITY),
        onFocus: e[8] || (e[8] = (l) => T(!0, o.CITY))
      }, null, 8, ["options", "value", "disabled"])) : S("", !0),
      I(o.AREA) ? (w(), E(U(Y), {
        key: 2,
        style: {
          display: "inline-block",
          flex: 1,
          minWidth: "100px"
        },
        options: d.value[o.AREA],
        value: i.value[o.AREA],
        "onUpdate:value": [
          e[9] || (e[9] = (l) => i.value[o.AREA] = l),
          e[10] || (e[10] = (l) => V(l, o.AREA))
        ],
        filterable: !0,
        placeholder: "选择区",
        placement: "bottom",
        "render-to-body": !1,
        disabled: R(o.AREA),
        onFocus: e[11] || (e[11] = (l) => T(!0, o.AREA))
      }, null, 8, ["options", "value", "disabled"])) : S("", !0),
      I(o.COUNTY) ? (w(), E(U(Y), {
        key: 3,
        style: {
          display: "inline-block",
          flex: 1,
          minWidth: "100px"
        },
        options: d.value[o.COUNTY],
        value: i.value[o.COUNTY],
        "onUpdate:value": [
          e[12] || (e[12] = (l) => i.value[o.COUNTY] = l),
          e[13] || (e[13] = (l) => V(l, o.COUNTY))
        ],
        filterable: !0,
        placeholder: "选择县/街道",
        placement: "bottom",
        "render-to-body": !1,
        disabled: R(o.COUNTY),
        onFocus: e[14] || (e[14] = (l) => T(!0, o.COUNTY))
      }, null, 8, ["options", "value", "disabled"])) : S("", !0)
    ], 4));
  }
});
export {
  ce as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/com-components/op-region-select/RegionSelect.vue.js
// module id = 824
// module chunks = 41